// extracted by mini-css-extract-plugin
export default {"row":"SettingDataEditor_row__YxWfm"};